import { useEffect, useReducer } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import HelmetTags from "../../../../MainComponents/HelmetTags";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function AdminAddStudentLecture() {
  const { lectureID } = useParams();
  const navigate = useNavigate();

  function reducer(state, action) {
    switch (action.type) {
      case "setErrors": {
        return {
          ...state,
          errors: action.payload,
        };
      }

      case "setSubmitAddStudentToLecture": {
        return {
          ...state,
          submitAddStudentToLecture: action.payload,
        };
      }

      default:
        throw Error("Unknown action: " + action.type);
    }
  }

  const [state, dispatch] = useReducer(reducer, {
    submitAddStudentToLecture: {
      flag: "",
      dependency: false,
      data: {},
    },
  });

  const [
    AddStudentToLectureSuccess,
    AddStudentToLectureErrors,
    AddStudentToLectureLoading,
  ] = useAxios(
    process.env.REACT_APP_ADMIN_ADD_STUDENT_TO_LECTURE_API,
    "POST",
    state.submitAddStudentToLecture.flag,
    state.submitAddStudentToLecture.dependency,
    state.submitAddStudentToLecture.data,
    true
  );

  useEffect(() => {
    //!---add actions ----
    if (AddStudentToLectureSuccess) {
      navigate(-1);
    }
  }, [AddStudentToLectureSuccess, navigate]);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({ mode: "onTouched" });

  const onSubmit = (data) => {
    const finalData = {
      ...data,
      lecture_id: lectureID,
    };
    dispatch({
      type: "setSubmitAddStudentToLecture",
      payload: {
        flag: "AddStudentToLecture",
        dependency: !state.submitAddStudentToLecture.dependency,
        data: finalData,
      },
    });
  };

  return (
    <section className="flex h-auto w-full flex-col  items-center  dark:bg-dark dark:text-light">
      <HelmetTags title="Add Student | Mr Ibrahim Abdel Masseh"></HelmetTags>

      <div className="form-container my-20 flex w-full flex-col items-center">
        <h2 className="my-20 text-center text-3xl font-semibold">
          Please fill this inputs to add student{" "}
        </h2>

        <form
          encType="multipart/form-data"
          method="post"
          onSubmit={handleSubmit(onSubmit)}
          className="md:max-w-3/4 flex  w-3/4  flex-col items-start justify-center gap-10 rounded-3xl bg-white p-16 shadow-3xl"
        >
          <div className="name flex w-full flex-col items-start justify-center  gap-2  md:w-full">
            <label
              className="text-start flex items-center gap-2"
              htmlFor="parent_mobile"
            >
              Username
            </label>
            <input
              className="signin-inputs max-w-60 "
              type="text"
              id="username"
              placeholder="User name"
              name="username"
              autoComplete="on"
              {...register("mobile", {
                required: true,
                pattern: /^[A-Za-z0-9-_]*$/,
                minLength: 3,
              })}
            />
            {errors.username && (
              <p className="mt-2 w-full text-start text-[12px] text-blue-900">
                {errors.username.type === "required" &&
                  "Please fill out this field"}
                {errors.username.type === "pattern" &&
                  "Please enter an 11-digit phone number"}
              </p>
            )}

            {
              //!-------server errors -----

              AddStudentToLectureErrors &&
                AddStudentToLectureErrors?.response?.data?.errors?.mobile && (
                  <p className="w-full text-end text-[12px] text-red-900  ">
                    {
                      AddStudentToLectureErrors?.response?.data?.errors
                        ?.mobile[0]
                    }
                  </p>
                )
            }
          </div>

          {/** submit */}
          <button
            disabled={
              !isValid ||
              (AddStudentToLectureLoading &&
                state.submitAddStudentToLecture.flag)
            }
            className=" submit mt-6 w-full "
            type="submit"
          >
            {AddStudentToLectureLoading &&
            state.submitAddStudentToLecture.flag ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              <p> Add Student</p>
            )}
          </button>
        </form>
      </div>
    </section>
  );
}

export default AdminAddStudentLecture;
